exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Ud8A{flex:0 0 auto;padding:0 18px 0 30px;color:#000;background:transparent}._3Cx30{flex:1 1 auto;margin:20px 0 0;font-size:18px;font-weight:400;text-align:center}._2R7n2{padding:10px;flex:0 0 auto;position:absolute;z-index:10;top:-28px;right:-10px;width:auto;height:auto;border-radius:50%;font-size:14px;background:transparent;color:hsla(0,0%,100%,.6)}._2R7n2:hover{background:none}", ""]);

// exports
exports.locals = {
	"header": "_2Ud8A",
	"title": "_3Cx30",
	"close-button": "_2R7n2",
	"closeButton": "_2R7n2"
};